import { Component, Inject, ViewChild, ElementRef } from '@angular/core';
import { NzModalRef, NZ_MODAL_DATA, NzModalService } from 'ng-zorro-antd/modal';
import Chart from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DataserviceService } from 'src/app/dataservice.service';

@Component({
  selector: 'app-area-modal',
  templateUrl: './area-modal.component.html',
  styleUrl: './area-modal.component.css'
})
export class AreaModalComponent {
  @ViewChild('pieChart', { static: true }) pieChart!: ElementRef;

  totalPins: any;
  segment = 'info'
  usersForm: FormGroup;
  dispForm: FormGroup;
  subSegment = 'list'
  currentUser: any;

  users: any[] = [];
  usersToDisplay: any;
  dispositions: any[] = [];

  saving: boolean = false;

  constructor(
    @Inject(NZ_MODAL_DATA) public modal: any,
    private modalRef: NzModalRef,
    private data: DataserviceService,
    private modalServ: NzModalService
  ) {

    this.usersForm = new FormGroup({
      'users': new FormControl(null),
      'color': new FormControl(null),
    });

    this.dispForm = new FormGroup({
      'disposition': new FormControl(null, [Validators.required]),
      'pinsToChange': new FormControl(null, [Validators.required])
    });

  }

  ngOnInit() {
    this.currentUser = JSON.parse(localStorage.getItem('user') || '{}');
    if(this.modal.data) {
      console.log(this.modal.data)
      this.totalPins = this.modal.data.pinIds?.length || 0;
      this.users = this.modal?.usersList
      const usersToDisp =  this.modal.data?.users?.map((  user: any) => `${user.first_name} ${user.last_name}`)
      this.usersToDisplay = usersToDisp?.join(', ') ?? 'No users available'
      this.dispositions = this.modal?.dispositions

      this.setValues();

      this.setUpChart();
    }
  }

  segmentChange(event: any) {
    this.segment = event;
  }
  
  subSegmentChange(event: any) {
    this.subSegment = event;
  }

  setValues() {
    this.usersForm.patchValue({
      'users': this.modal.data?.users,
      'color': this.modal.data?.color
    })
  }

  setUpChart() {
    const ctx = this.pieChart.nativeElement.getContext('2d');
  
    const labels = this.modal.data.pinsByDispositions?.map((item: any) =>
      item.disposition ? item.disposition : 'No disposition'
    );
    const data = this.modal.data.pinsByDispositions?.map((item: any) => parseInt(item.count, 10));
    const backgroundColors = this.modal.data.pinsByDispositions?.map((item: any) => item.pin || '#ccc');
  
    new Chart(ctx, {
      type: 'doughnut',
      data: {
        labels: labels,
        datasets: [{
          label: 'Disposition Counts',
          data: data,
          backgroundColor: backgroundColors,
          borderColor: backgroundColors,
          borderWidth: 1
        }]
      },
      options: {
        responsive: true,
        animation: {
          duration: 1500,
          easing: 'easeOutQuart',
          animateRotate: true,
          animateScale: true,
        },
        plugins: {
          legend: {
            display: false
          },
          datalabels: {
            display: false
          },
          tooltip: {
            callbacks: {
              label: function(context: any) {
                const label = context.label || '';
                const value = context.raw;
                return `${label}: ${value}`;
              }
            }
          }
        }
      }
    });
  }

  update() {
    if(this.usersForm.get('users')?.value?.length > 0) {
      let obj = {
        ...this.usersForm.value,
        updated: true
      }
  
      this.modalRef.close(obj)
    }else {
      alert('User(s) are required to create the area.')
    }
  }

  massDisp() {
    this.saving = true;
    let disp = this.dispositions.find((disp: any) => disp.id == this.dispForm.get('disposition')?.value);
    let obj = {
      pinIds: (this.modal.data.pinIds ?? [])
        .filter((r: any) => this.dispForm.get('pinsToChange')?.value.includes(r.disposition_id ?? null))
        .map((obj: any) => obj.pin_id),
      disposition: this.dispForm.get('disposition')?.value,
      color: disp.pin,
      provider: this.modal?.provider
    }

    this.data.postData(obj, `pins/mass-disposition`)
      .subscribe({
        next: (res: any) => {
          this.saving = false;
          this.modalRef.close({pins: obj.pinIds, pinColor: disp.pin})
        },
        error: (err: any) => {
          this.saving = false;
          alert('Failed to update pin dispositions')
        }
      })

  }

  delete() {
    const confirmModal = this.modalServ.confirm({
      nzTitle: 'Are you sure?',
      nzContent: 'Do you want to delete this area?',
      nzOnOk: () => {
        this.modalRef.close({delete: true});
      }
    });
  }

  cancel() {
    this.modalRef.close()
  }

  sortArr(data: any) {
    return data.sort((a: any, b: any) => b.count - a.count);
  }

  compareFn = (o1: any, o2: any): boolean => 
  o1 && o2 ? o1.id === o2.id && o1.company_id === o2.company_id : o1 === o2;

}
